/* eslint-disable import-x/first */
window.global ||= window;

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import analytics from 'react-segment';

import '@/utility/jquery';

// LOCALIZATION
import '@/locale/i18n';

// UTILITY
import bugsnagClient from '@/utility/bugsnagClient';

// STORE
import store from '@/store/configureStore';

// HOC
import Auth0ProviderWithHistory from '@/hoc/Auth0ProviderWithHistory';
import ErrorBoundary from '@/hoc/ErrorBoundary';

// COMPONENTS
import ScrollToTop from '@/components/ScrollToTop';

import App from '@/App';

// Segment
const segmentKey = import.meta.env.VITE_SEGMENT_KEY;

if (segmentKey) {
  analytics.default.load(segmentKey);
}

function render(retries = 2) {
  try {
    const container = document.getElementById('root');
    const root = createRoot(container);

    root.render(
      <StrictMode>
        <ErrorBoundary>
          <Auth0ProviderWithHistory>
            <Provider store={store}>
              <BrowserRouter
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <ScrollToTop />
                <App />
              </BrowserRouter>
            </Provider>
          </Auth0ProviderWithHistory>
        </ErrorBoundary>
      </StrictMode>,
    );
  } catch (error) {
    if (retries === 0) {
      throw error;
    }

    render(retries - 1);
  }
}

try {
  render();
} catch (error) {
  bugsnagClient.notify(new Error('React render is crashed', { cause: error }), event => {
    event.addMetadata('react', {
      document: document.documentElement.innerHTML,
    });
  });
}
